// imports
import { selectConfig as selectConfigSlice } from './lib/config';
import {
  selectUIMap as selectUIMapSlice,
  selectUIPrompt as selectUIPromptSlice,
  selectUIQuestProgress as selectUIQuestProgressSlice
} from './lib/ui';
import {
  selectUserId as selectUserIdSlice,
  selectUserHeroes as selectUserHeroesSlice,
  selectUserQuests as selectUserQuestsSlice,
  selectUserBackpack as selectUserBackpackSlice,
  selectUserPreferences as selectUserPreferencesSlice,
  selectUserDelegateWallet as selectUserDelegateWalletSlice
} from './lib/user';

// exports
export const selectConfig = selectConfigSlice;

export const selectUIMap = selectUIMapSlice;
export const selectUIPrompt = selectUIPromptSlice;
export const selectUIQuestProgress = selectUIQuestProgressSlice;

export const selectUserId = selectUserIdSlice;
export const selectUserHeroes = selectUserHeroesSlice;
export const selectUserQuests = selectUserQuestsSlice;
export const selectUserBackpack = selectUserBackpackSlice;
export const selectUserPreferences = selectUserPreferencesSlice;
export const selectUserDelegateWallet = selectUserDelegateWalletSlice;
